.item {
  align-items: flex-start;
}

.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.reason {
  font-size: var(--tuna-typography-caption-fontSize);
  line-height: var(--tuna-typography-caption-lineHeight);
  color: var(--tuna-content-secondary);
  white-space: normal;
  max-width: 260px;
}

/*
 * The shared menu dims a disabled item to opacity 0.38, which would make the reason unreadable.
 * Dim only the label and icon; keep the reason at secondary-text contrast (same as the section
 * Assist menu). Doubled class to outrank the shared rule.
 */
.item.item[data-disabled],
.item.item[aria-disabled='true'] {
  opacity: 1;
}

.item[data-disabled] .label,
.item[data-disabled] .icon,
.item[aria-disabled='true'] .label,
.item[aria-disabled='true'] .icon {
  color: var(--tuna-palette-text-disabled);
}
